export default __webpack_public_path__ + "static/media/borku-instagram.d5fec519.svg";